/* 

Component Footer

*/

import ComponentFooter from './ComponentFooter.jsx';

export default ComponentFooter;